import React, { useEffect } from 'react'
import AdminDashboardLayout from './AdminDashboardLayout'
import { useParams, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { base } from '../../constants/base'
import { getSingleUserAPI } from '../../redux/slices/SuperAdminUserSlice'
import './ProfileViewPage.css'

const UserViewPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const singleUser = useSelector(state => state?.superAdminUserSlice?.singleUser);
    const loading = useSelector(state => state?.superAdminUserSlice?.loading);
    const param = useParams();
    const id = param?.id;

    const fetchSingleUser = async () => {
        await dispatch(getSingleUserAPI(id));
    }

    useEffect(() => {
        fetchSingleUser();
    }, [id]);

    const getStatusClass = (status) => {
        switch (status?.toLowerCase()) {
            case 'active':
                return 'status-active';
            case 'block':
            case 'blocked':
                return 'status-blocked';
            default:
                return 'status-pending';
        }
    };

    return (
        <AdminDashboardLayout>
            <div className="profile-view-page">
                {/* Page Header */}
                <div className="pv-header">
                    <button className="pv-back-btn" onClick={() => navigate('/admin/users')}>
                        <i className="fas fa-arrow-left"></i>
                        <span>Back to Users</span>
                    </button>
                    <h1 className="pv-title">User Details</h1>
                </div>

                {loading ? (
                    <div className="pv-loading">
                        <div className="pv-loader"></div>
                    </div>
                ) : (
                    <div className="pv-content">
                        {/* Profile Card */}
                        <div className="pv-profile-card">
                            <div className="pv-profile-header">
                                <div className="pv-avatar-section">
                                    {singleUser?.images?.[0]?.path ? (
                                        <img
                                            src={`${base.imageUrl}${singleUser?.images?.[0]?.path}`}
                                            alt={singleUser?.name}
                                            className="pv-avatar"
                                        />
                                    ) : (
                                        <div className="pv-avatar-placeholder">
                                            <i className="fas fa-user"></i>
                                        </div>
                                    )}
                                </div>
                                <div className="pv-profile-info">
                                    <h2 className="pv-name">{singleUser?.name || '-'}</h2>
                                    <p className="pv-email">{singleUser?.email || '-'}</p>
                                    <div className="pv-badges">
                                        <span className="pv-role-badge">User</span>
                                        {singleUser?.status && (
                                            <span className={`pv-status-badge ${getStatusClass(singleUser?.status)}`}>
                                                {singleUser?.status}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Details Grid */}
                        <div className="pv-details-grid">
                            {/* Contact Information */}
                            <div className="pv-details-card">
                                <div className="pv-card-header">
                                    <i className="fas fa-address-book"></i>
                                    <h3>Contact Information</h3>
                                </div>
                                <div className="pv-card-body">
                                    {singleUser?.phone_no && (
                                        <div className="pv-info-row">
                                            <div className="pv-info-icon">
                                                <i className="fas fa-phone"></i>
                                            </div>
                                            <div className="pv-info-content">
                                                <span className="pv-info-label">Phone Number</span>
                                                <span className="pv-info-value">{singleUser?.phone_no}</span>
                                            </div>
                                        </div>
                                    )}
                                    {singleUser?.address?.address && (
                                        <div className="pv-info-row">
                                            <div className="pv-info-icon">
                                                <i className="fas fa-location-dot"></i>
                                            </div>
                                            <div className="pv-info-content">
                                                <span className="pv-info-label">Address</span>
                                                <span className="pv-info-value">{singleUser?.address?.address}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Identification */}
                            <div className="pv-details-card">
                                <div className="pv-card-header">
                                    <i className="fas fa-id-card"></i>
                                    <h3>Identification</h3>
                                </div>
                                <div className="pv-card-body">
                                    {singleUser?.ss_number && (
                                        <div className="pv-info-row">
                                            <div className="pv-info-icon">
                                                <i className="fas fa-address-card"></i>
                                            </div>
                                            <div className="pv-info-content">
                                                <span className="pv-info-label">Social Security Number</span>
                                                <span className="pv-info-value">{singleUser?.ss_number}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* About */}
                            {singleUser?.about && (
                                <div className="pv-details-card pv-full-width">
                                    <div className="pv-card-header">
                                        <i className="fas fa-info-circle"></i>
                                        <h3>About</h3>
                                    </div>
                                    <div className="pv-card-body">
                                        <p className="pv-about-text">{singleUser?.about}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </AdminDashboardLayout>
    )
}

export default UserViewPage
